import React from 'react';

import { useTranslation } from 'hooks/useTranslation';
import { Title } from 'shared';

import { SignUp } from 'features/auth/components/SignUp';

export const SignUpPage = () => {
  const { t } = useTranslation('auth');

  return (
    <>
      <Title title={t('signUp')} />
      <SignUp />
    </>
  );
};
